import { render, staticRenderFns } from "./WorkflowFormBuilderMetaLabelColumnsDialog.vue?vue&type=template&id=6df9cfd3&"
import script from "./WorkflowFormBuilderMetaLabelColumnsDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderMetaLabelColumnsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports